import { QueryClient } from '@tanstack/react-query';

/**
 * Central QueryClient instance used across the Insights app.
 * Keeps defaults conservative until individual hooks override them.
 */
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
            retry: 1,
            staleTime: 30_000,
            gcTime: 5 * 60_000,
        },
        mutations: {
            retry: 1,
        },
    },
});

export default queryClient;
